import req from "../http";

const certificate = {
  // 取得 證照
  getCertificate(params) {
    return req("get", "/BasicInformation/CertificateCategory/WithDetail", params);
  },
};

export default certificate;